<template>
  <OfflineLayout>
    <ChangePasswordForm />
  </OfflineLayout>
</template>

<script>
import OfflineLayout from "@/layouts/OfflineLayout";
import ChangePasswordForm from "@/components/ChangePasswordForm";

export default {
  name: 'ResetPasswordView',
  components: {ChangePasswordForm, OfflineLayout}
}
</script>

<style scoped>

</style>

